import { signal, WritableSignal } from "@angular/core";
import { AppAvailabilityDto } from "../http";



export class AppAvailability
{
  public catalog: WritableSignal<boolean>;
  public library: WritableSignal<boolean>;
  public servicesMatrix: WritableSignal<boolean>;
  public spaceBot: WritableSignal<boolean>;
  public management: WritableSignal<boolean>;

  constructor()
  {
    this.catalog = signal<boolean>(false);
    this.library = signal<boolean>(false);
    this.servicesMatrix = signal<boolean>(false);
    this.spaceBot = signal<boolean>(false);
    this.management = signal<boolean>(false);
  }

  public static fromDto(dto: AppAvailabilityDto)
  {
    const app = new AppAvailability();
    app.catalog.set(dto.catalog);
    app.library.set(dto.library);
    app.servicesMatrix.set(dto.servicesMatrix);
    app.spaceBot.set(dto.spaceBot);
    app.management.set(dto.management)
    return app;
  }

}